define( 'models/partCollection',[ 'models/partModel' ], function( PartModel ) {
	var collection = Backbone.Collection.extend( {
		model: PartModel,
		currentElement: false,

		initialize: function( models, options ){
			this.formModel = options.formModel;
		},
		
		getElement: function() {
			/*
			 * If we haven't set an element yet, set it to the first one.
			 */
			if ( ! this.currentElement ) {
				this.setElement( this.at( 0 ), true );
			}
			return this.currentElement;
		},

		setElement: function( model, silent ) {
			silent = silent || false;

			/*
			 * If we have part errors and aren't updating silently, check for part errors.
			 */
			if ( ! silent ) {
				if ( this.partErrors() ) return;
			}
			
			this.currentElement = model;
			if ( ! silent ) {
				this.trigger( 'change:part', this );
				nfRadio.channel( 'nfMP' ).trigger( 'change:part', this );
			} 
		},
		  
		// check for errors on Next click if we have validate parts on
		setNextElement: function( model, silent ) {
			silent = silent || false;

			/*
			 * If we have part errors and aren't updating silently, check for part errors.
			 */
			if ( ! silent ) {
				if ( this.partErrors() ) return;
			}
			
			this.currentElement = model;
			if ( ! silent ) {
				this.trigger( 'change:part', this );
				nfRadio.channel( 'nfMP' ).trigger( 'change:part', this );
			} 
		},

		// We don't want to stop user from moving back in the form if there are errors
		setPreviousElement: function( model, silent ) {
			silent = silent || false;
			
			this.currentElement = model;
			if ( ! silent ) {
				this.trigger( 'change:part', this );
				nfRadio.channel( 'nfMP' ).trigger( 'change:part', this );
			}
		},
		
		next: function (){
			/*
			 * If this isn't the last visible part, move forward.
			 */
			if ( this.getVisibleParts().length - 1 != this.getVisibleParts().indexOf( this.getElement() ) ) {
				this.setNextElement( this.getVisibleParts()[ this.getVisibleParts().indexOf( this.getElement() ) + 1 ] );
			}
			
			return this;
		},

		previous: function() {
			/*
			 * If this isn't the first visible part, move backward.
			 */
			if ( 0 != this.getVisibleParts().indexOf( this.getElement() ) ) {
				this.setPreviousElement( this.getVisibleParts()[ this.getVisibleParts().indexOf( this.getElement() ) - 1 ] );	
			}
			
			return this;
		},

		partErrors: function() {
			if ( 'undefined' == typeof this.formModel.get( 'settings' ).mp_validate || 0 == this.formModel.get( 'settings' ).mp_validate ) return false;
			this._cascadeHiddenPartRepeaterChildren();

			// Two suppression groups — both set visible=false silently before validation,
			// restored after. validateRequired gates on visible, so suppressed children
			// are skipped. Group 1: children from other visible parts (Layouts fetches ALL
			// form children via get:repeaterFieldsModelsArrayByForm). Group 2: children of
			// Repeater fields that are individually hidden by CL within the current part —
			// the Repeater add-on does not cascade visibility from the field to its children.
			var nonCurrentChildren = this._getNonCurrentPartRepeaterChildren();
			var hiddenRepeaterChildren = this.currentElement.getHiddenRepeaterChildModels();
			var suppressedChildren = nonCurrentChildren.concat( hiddenRepeaterChildren );
			// Capture each child's real visibility before suppressing so it can be restored
			// afterward, rather than assumed. hiddenRepeaterChildren are always visible:false
			// here by construction, but nonCurrentChildren can be either — blindly restoring
			// to true (the previous behavior) silently and permanently un-hides a Repeater
			// that CL had correctly hidden the moment any validation runs against this part.
			var priorVisibility = _.map( suppressedChildren, function( child ) { return child.get( 'visible' ); } );
			_.each( suppressedChildren, function( child ) { child.set( 'visible', false, { silent: true } ); } );

			this.currentElement.validateFields();

			_.each( suppressedChildren, function( child, i ) { child.set( 'visible', priorVisibility[ i ], { silent: true } ); } );

			// Scrub any pre-existing fieldErrors for hidden-Repeater children in the current
			// part. Suppression above blocks new errors during this run; this removes stale
			// ones left from a previous Next attempt before the Repeater was hidden.
			var formFieldErrors = this.formModel.get( 'fieldErrors' );
			if ( formFieldErrors ) {
				_.each( hiddenRepeaterChildren, function( child ) {
					var id = child.get ? child.get( 'id' ) : child.id;
					if ( id ) delete formFieldErrors[ String( id ) ];
				} );
			}

			// Repeater child errors don't bubble up to partModel.errors via maybeChangeActivePart.
			// Evaluate them explicitly and sync the errors flag each time so Next blocks/unblocks
			// correctly even after a failed attempt where the user then fills in the field.
			var hasRepeaterErrors = this.currentElement.hasRepeaterChildErrors( this.formModel );

			if ( hasRepeaterErrors ) {
				this.currentElement.set( 'errors', true );
				return true;
			}

			// No Repeater child errors. If the standard field-error tracker is also empty,
			// reset the part's errors flag — it may be stale from a previous failed attempt.
			if ( 0 === this.currentElement.fieldErrors[ this.currentElement.cid ].length ) {
				this.currentElement.set( 'errors', false );
			}

			return this.currentElement.get( 'errors' );
		},

		validateFields: function() {
			this._cascadeHiddenPartRepeaterChildren();

			// Collect children of Repeater fields individually hidden (via CL) within
			// each visible part. The Repeater add-on does not cascade visibility from
			// the field to its children, so without suppression validateRequired would
			// treat them as required and block submission.
			var hiddenRepeaterChildren = [];
			_.each( this.getVisibleParts(), function( partModel ) {
				hiddenRepeaterChildren = hiddenRepeaterChildren.concat( partModel.getHiddenRepeaterChildModels() );
			} );
			_.each( hiddenRepeaterChildren, function( child ) { child.set( 'visible', false, { silent: true } ); } );

			_.each( this.getVisibleParts(), function( partModel ) { partModel.validateFields(); } );

			// hiddenRepeaterChildren are always visible:false prior to suppression (that's how
			// getHiddenRepeaterChildModels() selects them), so restore to false here, not true —
			// see the matching fix in partErrors() above for the full explanation.
			_.each( hiddenRepeaterChildren, function( child ) { child.set( 'visible', false, { silent: true } ); } );

			var formFieldErrors = this.formModel && this.formModel.get( 'fieldErrors' );
			if ( formFieldErrors ) {
				_.each( hiddenRepeaterChildren, function( child ) {
					var id = child.get ? child.get( 'id' ) : child.id;
					if ( id ) delete formFieldErrors[ String( id ) ];
				} );
			}
		},

		_cascadeHiddenPartRepeaterChildren: function() {
			this.each( function( partModel ) {
				if ( ! partModel.get( 'visible' ) ) {
					partModel.cascadeRepeaterChildrenVisible( false );
				}
			} );
		},

		// Returns the child field models for all Repeaters that live in visible parts
		// other than the current element. Used to temporarily suppress their visibility
		// during current-part validation so Layouts' global child lookup doesn't validate them.
		_getNonCurrentPartRepeaterChildren: function() {
			var self = this;
			var children = [];
			this.each( function( partModel ) {
				if ( partModel === self.currentElement ) return;
				if ( ! partModel.get( 'visible' ) ) return;
				_.each( partModel.getRepeaterFieldIds(), function( repeaterFieldId ) {
					var fieldset = nfRadio.channel( 'field-repeater' ).request( 'get:repeaterFields', repeaterFieldId );
					if ( fieldset && fieldset.fields ) {
						children = children.concat( fieldset.fields );
					}
				} );
			} );
			return children;
		},

		getVisibleParts: function() {
			return this.where( { visible: true } );
		}
	} );

	return collection;
} );
